import Icon from './icon'
import { IconProps } from './icon.types'

const ClockIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <g id="clock" clipPath="url(#clip0_10542_1523)">
        <path
          id="Icon"
          d="M8.00004 4.0026V8.0026L10.6667 9.33594M14.6667 8.0026C14.6667 11.6845 11.6819 14.6693 8.00004 14.6693C4.31814 14.6693 1.33337 11.6845 1.33337 8.0026C1.33337 4.32071 4.31814 1.33594 8.00004 1.33594C11.6819 1.33594 14.6667 4.32071 14.6667 8.0026Z"
          stroke={props.stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10542_1523">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}

export default ClockIcon
